import { lazy } from "react";

const routes = [
  {
    path: "/subdistrict",
    element: lazy(() => import("../pages/SubDistrict")),
  },
  {
    path: "/subdistrict/add",
    element: lazy(() => import("../pages/SubDistrict/create")),
  },
  {
    path: "/subdistrict/edit/:id",
    element: lazy(() => import("../pages/SubDistrict/edit")),
  },
];

export default routes;
